import React from 'react';

import { css } from '@emotion/css';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useKeycloak } from '@/auth/KeycloakAuthState.ts';

export const AdminPage: React.FC = () => {
  const keycloak = useKeycloak(state => state.keycloak);
  const { t } = useTranslation();
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
      `}
      id="admin-page"
    >
      <Typography id="admin-title" variant="h4">
        {t('admin.title')}
      </Typography>
      <Button
        id="admin-logout"
        variant="contained"
        onClick={() =>
          keycloak.logout({
            redirectUri: window.origin,
          })
        }
      >
        {t('admin.logout')}
      </Button>
    </div>
  );
};
